<template>
  <section class="main_content">
    <div class="shopping_game">
      <h2>{{$t('playAndWin')}}</h2>
      <ul class="game_card" v-for="(game_list,index) in shopping_game_List " :key="index" @click="OnSubmit(game_list.link)">
        <li class="card_section">
          <div class="img_wrapper">
            <img :src="require(`../assets/images/icons/${game_list.img}`)" alt="random image" />
          </div>
          <div class="card_content">
            <h3>{{game_list.title}}</h3>
            <ul>
              <li v-for="(list,inner_Index) in game_list.inner_Details " :key="inner_Index">
                <span></span>
                {{list}}
              </li>
            </ul>
          </div>
        </li>
        <li class="button_wrapper">
          <button type="button" class="buy_now" >{{$t('buyNow')}}</button>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "ShoppingGame",
  data() {
    return {
      shopping_game_List: [
        {
          img: "Mega Discount.svg",
          title: "GROUP MEGA DISCOUNT",
          link: "groups-product-listing/",
          inner_Details : [
            this.$t('createAGroup'),
            this.$t('invitefriends'),
            this.$t('completeGroup'),
            this.$t('saveTogether')
          ]
        },
        {
          img: "cuttheprice.png",
          title: "CUT THE PRICE",
          link: "cutprice-product-listing/",
          inner_Details: [
            this.$t('selectProduct'),
            this.$t('addYourFriend'),
            this.$t('lessAmount'),
            this.$t('getInFree')
          ]
        },
        // {
        //   img: "oye-lucky",
        //   title: "OYE LUCKY LUCKY OYE",
        //   link: "",
        //   inner_Details: [
        //     "डील देखे",
        //     "फ्रेंड्स को जोड़े",
        //     "खरीद को पूरा करे",
        //     "एक लकी विजेता "
        //   ]
        // }
      ]
    };
  },
  mounted() {},
  methods: {
    OnSubmit(link) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push(`/${link}`);
    }
  }
};
</script>
